var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{ref:"downloadHelper",staticClass:"d-none",attrs:{"target":"_blank"}}),_c('v-btn',{attrs:{"color":_vm.color,"outline":""},on:{"click":function($event){return _vm.exportData()}}},[_vm._v(_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }